import { render, staticRenderFns } from "./PlantillaImpresion.vue?vue&type=template&id=30c9d3a0&scoped=true&"
import script from "./PlantillaImpresion.vue?vue&type=script&lang=js&"
export * from "./PlantillaImpresion.vue?vue&type=script&lang=js&"
import style0 from "./PlantillaImpresion.vue?vue&type=style&index=0&id=30c9d3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9d3a0",
  null
  
)

export default component.exports